module.exports = __webpack_public_path__ + "static/media/IconResultSuccess.1769ad43.svg";